import { render, staticRenderFns } from "./SurveyModalShell.vue?vue&type=template&id=86811e82&scoped=true"
import script from "./SurveyModalShell.vue?vue&type=script&lang=ts"
export * from "./SurveyModalShell.vue?vue&type=script&lang=ts"
import style0 from "./SurveyModalShell.vue?vue&type=style&index=0&id=86811e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86811e82",
  null
  
)

export default component.exports